<template>
  <div class="tw-rounded-md tw-border tw-border-neutral-200 tw-p-5">
    <a
      :href="element.url"
      class="tw-font-semibold tw-transition-colors hover:tw-text-current hover:tw-text-neutral-700"
      target="_blank"
    >
      {{ element.title }}
      <ExternalLinkIcon class="-tw-mt-0.5 tw-inline tw-h-4 tw-w-4" />
    </a>
    <div class="tw-mt-1 tw-text-xs tw-text-neutral-500">
      Posted in
      <a
        href="https://www.growthmentor.com/blog/category/mentor-column/"
        target="_blank"
        class="tw-link"
      >
        Mentor Column
      </a>
      on {{ formatDate(element.createdAt, 'dd MMMM yyyy') }}
    </div>
  </div>
</template>

<script setup>
import ExternalLinkIcon from '@/assets/images/icons/external-link.svg'
import { useDateManager } from '@/shared/composables/useDateManager.js'

defineProps({
  element: {
    type: Object,
    required: true,
  },
})

const { formatDate } = useDateManager()
</script>
